export const TABLE_BORDER_GRAY = "1px solid rgb(81, 81, 81)";
export const BACKGROUND_GRAY = "#707072";
export const LIGHT_BACKGROUND_GRAY = "#CACACB";
export const GREEN_05 = "#DFFFB9";
export const GREEN_40 = "#3CCD49";
export const GREEN_30 = "#7ac281";
export const YELLOW_30 = "#FFD11B";

export const RED_40 = "#FF4E4A";
export const RED_50 = "#EE0005";

export const BLUE_40 = "#0034E3";
export const BLUE_30 = "#4CABFF";

export const SUBMIT_BUTTON_STYLES = (backgroundColor: string) => ({
  color: "#fff",
  fontSize: "large",
  width: "150px",
  height: "75px",
  backgroundColor,
  margin: "40px 40px 0 0",
});
